import { CmsCardPage } from '../../models/cms/cms-card-page.type';
import { mockCmsCardForm } from './cms-card-form.mock';
import { mockCmsProtectionStartSummaryPanelBoilers } from './cms-protection-start-summary-panel-boilers.mock';
import { mockCmsProtectionStartSummaryPanelWhiteGoods } from './cms-protection-start-summary-panel-white-goods.mock';

export const mockCmsCardPage: CmsCardPage = {
  ...mockCmsCardForm,
  ...mockCmsProtectionStartSummaryPanelBoilers,
  ...mockCmsProtectionStartSummaryPanelWhiteGoods,
  pageTitle: 'Set up your payment',
};
